import styled from 'styled-components'

export const WorkWithUsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;

  gap: 48px;
  padding: 0 96.5px;
  margin-bottom: 112px;

  background-color: ${({ theme }) => theme.colors.white};

  a {
    z-index: 20;
    button {
      background-color: transparent;
      color: ${({ theme }) => theme.colors.primary_4};
      border: 2px solid ${({ theme }) => theme.colors.primary_4};
    }
  }

  .title {
    width: 100%;
    align-self: flex-start;
    background-color: ${({ theme }) => theme.colors.white};
  }

  .image-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 740px;
    width: 100%;
    gap: 48px;
  }

  @media (max-width: 922px) {
    padding: 0 28px;
    .image-container {
      height: 493px;
      gap: 28px;
    }
  }

  @media (max-width: 742px) {
    padding: 0 28px;
    margin-bottom: 40px;
    .image-container {
      height: 293px;
    }
  }
`

export const TopRowImageContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: calc(1440px - 96.5px * 2);

  top: 195px;

  div:nth-child(2n) {
    margin-top: 113px;
  }

  @media (max-width: 922px) {
    top: 53px;
    justify-content: space-around;
    div {
      width: 97px;
      height: 106px;
      margin-top: 0;
    }

    div:nth-child(2n) {
      margin-top: 0;
    }
  }
  @media (max-width: 791px) {
    width: 80%;
  }
`

export const BottomRowImageContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: calc(1440px - 96.5px * 2);
  position: relative;

  bottom: 0px;

  div:nth-child(2n) {
    margin-top: 113px;
  }

  @media (max-width: 922px) {
    left: 44px;
    justify-content: space-around;
    div {
      width: 97px;
      height: 106px;
      margin-top: 0;
    }
    div:nth-child(2n) {
      margin-top: 0px;
    }
  }
  @media (max-width: 791px) {
    width: 80%;
    left: 22px;
  }
`
